import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { BusinessProfile, getBusinessProfile, lookUpBusiness, saveBusinessProfile } from '../../../api/businessProfile';

export const BusinessProfileQueryKey = 'BUSINESS_PROFILE';

export const useBusinessProfileQuery = () =>
  useQuery({ queryKey: [BusinessProfileQueryKey], queryFn: getBusinessProfile });

export const useSaveBusinessProfileMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (profile: BusinessProfile) => saveBusinessProfile(profile),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: [BusinessProfileQueryKey] }),
  });
};

export const useLookUpBusinessMutation = () =>
  useMutation({ mutationFn: (orgNumber: string) => lookUpBusiness(orgNumber) });
